var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',[_c('h5',[_vm._v("Dashboard")]),_c('hr'),_c('div',[(_vm.user.is_barangay_leader)?_c('barangay-analytics',{attrs:{"barangay_id":_vm.user.barangay_id}}):_c('admin-overview')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }